var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"emoji-input"},_vm._l((_vm.DataStore.emojiList),function(item,index){return _c('div',{key:index,staticClass:"emoji-item",on:{"click":function($event){return _vm.$emit('click', item)}}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }